<div class="top-info-banner">
  <div class="banner-content">
    <div class="banner-item" (click)="modal.open('sucursal-modal-1')">
      <i class="mdi mdi-map-marker banner-icon" style="color: var(--navbarColorTexto, white); font-size: 1rem;"></i>
      <span class="clickable">Seleccionar sucursal</span>
    </div>
  </div>
</div>

<div class="header-main" [class.is-scrolled]="scroll">
  <div class="header-container">

    <!-- Brand & Categories -->
    <div class="brand-section">
      <div class="logo-wrapper" (click)="iraLand()">
        <img [src]="logosrc" class="main-logo" alt="logo">
      </div>
      <div class="category-trigger">
        <categorias-generico></categorias-generico>
      </div>
    </div>

    <!-- Prominent Search -->
    <div class="search-section">
      <div class="search-wrapper">
        <searchview-generic></searchview-generic>
      </div>
    </div>

    <!-- Actions -->
    <div class="actions-section">
      <div class="cart-wrapper">
        <carrito-generico></carrito-generico>
      </div>

      <div class="user-budget">
        <mmax-usuario-budget></mmax-usuario-budget>
      </div>

      <button *ngIf="genServ.puedePivotearListaCF()" type="button" class="btn-lista-cf" (click)="genServ.alternarVistaListaMayoristaCF()">
        {{ genServ.getTextoBotonListaCF() }}
      </button>
    </div>

    <!-- Mobile Actions -->
    <div class="mobile-actions">
      <categorias-generico class="mobile-cat"></categorias-generico>
    </div>
  </div>
</div>

<modal-open-point [mode]="'noBackground'" id="sucursal-modal-1">

  <div noBackground class="mybody">
    <sucursales-mmax></sucursales-mmax>
    <div class="cerrar" (click)="cerrarModale('sucursal-modal-1')">X</div>
  </div>

</modal-open-point>

<modal-open-point [deshabilitarClickFueraDeContexto]="true" id="hay-carrito-offline">
  <div normal>
    <hay-carrito-offline></hay-carrito-offline>
  </div>
</modal-open-point>